import React, { useState } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const cards = [
  {
    titulo: 'Pagar una multa es reconocer la infracción',
    subtitulo: 'Genera antecedentes',
    parrafos: [
      'Cuando aceptás el pago voluntario con descuento, la ley lo considera como un reconocimiento de la infracción.',
      'Esto produce una sanción firme y deja registro en tu historial, lo que puede influir en futuras infracciones.',
      'En otras palabras: pagar no es solo cerrar el problema, es admitirlo legalmente y generar antecedentes.',
    ],
    ley: 'Ley Nacional de Tránsito 24.449 – Artículo 85',
    cita: [
      'La sanción de multa puede:',
      'a) Abonarse con una reducción del CINCUENTA POR CIENTO (50%) […] cuando exista reconocimiento voluntario de la infracción. En todos los casos tendrá los efectos de una sanción firme;',
      'b) Ser exigida mediante un sistema de cobro por vía ejecutiva […].',
    ],
  },
  {
    titulo: 'Tener antecedentes aumenta tus multas',
    subtitulo: 'La ley contempla la reincidencia',
    parrafos: [
      'Si ya fuiste sancionado y cometés una nueva infracción, se considera reincidencia.',
      'Esto puede hacer que la multa aumente progresivamente y que incluso se aplique una inhabilitación para conducir.',
      'Cuantos más antecedentes tengas, mayor puede ser la sanción.',
    ],
    ley: 'Ley Nacional de Tránsito 24.449 – Artículo 82',
    cita: [
      'Hay reincidencia cuando el infractor cometa una nueva falta habiendo sido sancionado anteriormente en cualquier jurisdicción…',
      'La sanción de multa se aumenta:',
      '1. Para la primera, en un cuarto;',
      '2. Para la segunda, en un medio;',
      '3. Para la tercera, en tres cuartos…',
    ],
  },
  {
    titulo: 'Dejar que pasen los días te puede condenar',
    subtitulo: 'El proceso sigue aunque no actúes',
    parrafos: [
      'Cuando una infracción es notificada, comienza un procedimiento legal con plazos concretos.',
      'Si no respondés, no presentás descargo ni intervenís, el juzgado puede avanzar igual.',
      'Podés ser declarado en rebeldía, y el Órgano de Juzgamiento puede resolver sin escucharte, aplicarte una sanción y ordenar su registro en sistemas oficiales.',
      'Esto significa consentir la falta imputada y perder tu derecho de defensa y quedar expuesto a una sanción firme.',
    ],
    ley: 'Provincia de Buenos Aires – Ley 13.927 – Artículo 36 inciso g)',
    cita: [
      '…ante la incomparecencia del causante, el Órgano de Juzgamiento resolverá y ordenará la correspondiente anotación en el Registro Único de Infractores…',
    ],
  },
  {
    titulo: 'Pagar una multa es anotarla por 10 años',
    subtitulo: 'Genera antecedentes en tu historial',
    parrafos: [
      'Una sanción firme tiene consecuencias a largo plazo, condicionando tu situación frente a futuras infracciones y decisiones administrativas.',
      'Cuando aceptás el pago voluntario, vos reconocés la falta imputada.',
      'Esto deja un antecedente registrado que puede permanecer hasta 10 años.',
    ],
    ley: 'Provincia de Buenos Aires – Ley 13.927 (texto según Ley 15.002) – Artículo 5',
    cita: [
      'Las anotaciones de los antecedentes personales […] caducarán a los diez (10) años contados desde la fecha del hecho…',
    ],
  },
  {
    titulo: 'Una multa impaga puede terminar en cobro judicial',
    subtitulo: 'El Estado puede ejecutarla por vía legal',
    parrafos: [
      'Cuando una infracción queda firme y no se paga, la ley permite que el Estado inicie su cobro por vía de apremio.',
      'Esto significa que la deuda puede ser ejecutada judicialmente, con actualización de montos, intereses y costos adicionales hasta su efectivo pago.',
      'El paso del tiempo no elimina la deuda: puede aumentar su valor y complicar su resolución.',
    ],
    ley: 'Provincia de Buenos Aires – Ley 13.927 – Artículo 35 Bis',
    cita: [
      '…se procederá a su ejecución por vía de apremio…',
      '…hasta su total y efectivo pago, con más los intereses correspondientes…',
    ],
  },
  {
    titulo: 'Creer que la multa va a caducar puede ser un error',
    subtitulo: 'La prescripción puede interrumpirse',
    parrafos: [
      'Muchas personas piensan que, si dejan pasar el tiempo, la multa desaparece por sí sola.',
      'Si bien la ley establece plazos de prescripción, esos plazos pueden interrumpirse.',
      'Esto ocurre, por ejemplo, cuando cometés una nueva infracción grave o cuando el proceso judicial avanza.',
      'En esos casos, el tiempo vuelve a correr y la multa puede seguir vigente.',
    ],
    ley: 'Ley Nacional de Tránsito 24.449 – Artículo 89',
    cita: [
      'La prescripción se opera:',
      'a) A los DOS (2) años para la acción por falta leve;',
      'b) A los CINCO (5) años para la acción por falta grave […]',
      'En todos los casos, se interrumpe por la comisión de una falta grave o por la secuela del juicio…',
    ],
  },
];

const Tips = () => {
  const [ref, isVisible] = useScrollAnimation();
  const [showLegal, setShowLegal] = useState({});

  const toggleLegal = (index) => {
    setShowLegal((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <section id="tips" className="bg-light">
      <div style={{ marginTop: '-1px', lineHeight: 0 }}>
        <img
          src={`${process.env.PUBLIC_URL || ''}/images/wave-sobrenosotros.svg`}
          alt=""
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
      </div>
      <div className="container py-5" ref={ref}>
        <h2
          className={`text-center mb-5 fw-bold titulo-seccion-desktop ${isVisible ? 'animate-fade-in' : ''}`}
        >
          Antecedentes y consecuencias de las fotomultas
        </h2>
        <div className="row g-4 mt-2 mt-lg-3">
          {cards.map((card, index) => {
            const isLegalVisible = Boolean(showLegal[index]);
            return (
              <div key={card.titulo} className="col-md-6 col-xl-4">
                <article
                  className={`card h-100 border-0 shadow-sm ${isVisible ? `animate-on-scroll card-animate-${(index % 4) + 1}` : ''}`}
                  aria-live="polite"
                >
                  <div className="card-body d-flex flex-column h-100 p-4">
                    {!isLegalVisible ? (
                      <>
                        <h3 className="h5 fw-bold text-uppercase mb-2" style={{ color: '#1e3a5f' }}>
                          {card.titulo}
                        </h3>
                        <p className="fw-semibold text-primary mb-3 small">{card.subtitulo}</p>
                        <div className="flex-grow-1">
                          {card.parrafos.map((p, i) => (
                            <p key={i} className="card-text text-muted small mb-3">
                              {p}
                            </p>
                          ))}
                        </div>
                        <button
                          type="button"
                          className="btn btn-primary w-100 mt-3"
                          onClick={() => toggleLegal(index)}
                          aria-expanded={isLegalVisible}
                          aria-label={`Ver respaldo legal: ${card.titulo}`}
                        >
                          <i className="bi bi-journal-text me-2" aria-hidden="true" />
                          Respaldo legal
                        </button>
                      </>
                    ) : (
                      <>
                        <h4 className="h6 fw-bold text-uppercase mb-3" style={{ color: '#1e3a5f' }}>
                          <i className="bi bi-shield-check text-primary me-2" aria-hidden="true" />
                          Respaldo legal
                        </h4>
                        <p className="small fw-bold mb-3" style={{ color: '#1e3a5f' }}>
                          {card.ley}
                        </p>
                        <figure className="flex-grow-1 mb-3">
                          <blockquote className="blockquote small text-muted mb-0 border-start border-primary border-3 ps-3">
                            {card.cita.map((linea, i) => (
                              <p key={i} className={`mb-0 ${i > 0 ? 'mt-2' : ''}`}>
                                {linea}
                              </p>
                            ))}
                          </blockquote>
                        </figure>
                        <button
                          type="button"
                          className="btn btn-outline-primary w-100 mt-3"
                          onClick={() => toggleLegal(index)}
                          aria-label={`Volver al resumen: ${card.titulo}`}
                        >
                          <i className="bi bi-arrow-counterclockwise me-2" aria-hidden="true" />
                          Volver
                        </button>
                      </>
                    )}
                  </div>
                </article>
              </div>
            );
          })}
        </div>
      </div>
      <div style={{ marginTop: '-1px', lineHeight: 0 }}>
        <img
          src={`${process.env.PUBLIC_URL || ''}/images/wave-tips.svg`}
          alt=""
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
      </div>
    </section>
  );
};

export default Tips;
